'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalVenueList = exports.MIN_SHOWABLE_VENUES = exports.MAX_SHOWABLE_VENUES = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _deep = require('helpers/deep');

var _StarRating = require('components/StarRating/StarRating');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_SHOWABLE_VENUES = exports.MAX_SHOWABLE_VENUES = 20;
var MIN_SHOWABLE_VENUES = exports.MIN_SHOWABLE_VENUES = 6;

var VerticalVenueList = exports.VerticalVenueList = function (_Component) {
  (0, _inherits3.default)(VerticalVenueList, _Component);

  function VerticalVenueList() {
    var _ref;

    var _temp, _this, _this3, _ret;

    (0, _classCallCheck3.default)(this, VerticalVenueList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = VerticalVenueList.__proto__ || (0, _getPrototypeOf2.default)(VerticalVenueList)).call.apply(_ref, [this].concat(args))), _this3), _this3.state = {
      showMaxNumItems: false
    }, _this3.handleLoadMore = function () {
      _this.setState({ showMaxNumItems: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this3, _ret);
  }

  (0, _createClass3.default)(VerticalVenueList, [{
    key: 'renderVenueItem',
    value: function renderVenueItem(element) {
      var showCount = this.props.showCount;

      var imgUrl = (0, _deep.deepExtract)('images.default', element);
      var locationName = (0, _deep.deepExtract)('location.name', element);
      var ratingMean = (0, _deep.deepExtract)('ratings.mean', element);
      var hasRating = ratingMean > 0;
      var activities = (0, _deep.deepExtract)('activities', element);
      var ratingCount = (0, _deep.deepExtract)('ratings.display_total', element);

      return _react2.default.createElement(
        'div',
        { className: 'mb', key: element.id },
        _react2.default.createElement(
          'a',
          { href: '/studios/' + element.alias },
          _react2.default.createElement(
            'div',
            { className: 'vertical-venue-list__item' },
            _react2.default.createElement('div', { className: 'vertical-venue-list__item__image', style: { backgroundImage: 'url(' + imgUrl + ')' } }),
            _react2.default.createElement(
              'div',
              { className: 'vertical-venue-list__item__content' },
              _react2.default.createElement(
                'h5',
                null,
                element.name
              ),
              hasRating && _react2.default.createElement(_StarRating.StarRating, {
                showRatingNumber: !showCount,
                rating: ratingMean,
                count: showCount && ratingCount && ratingCount + ' ratings'
              }),
              locationName && _react2.default.createElement(
                'p',
                { className: 'vertical-venue-list__item__content__location mb-' },
                locationName
              ),
              activities && _react2.default.createElement(
                'p',
                { className: 'vertical-venue-list__item__content__activities text--light' },
                activities.split(',')[0].trim()
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var elements = this.props.elements;
      var showMaxNumItems = this.state.showMaxNumItems;

      var numItems = showMaxNumItems ? MAX_SHOWABLE_VENUES : MIN_SHOWABLE_VENUES;
      var canShowLoadMore = !showMaxNumItems && elements.length > MIN_SHOWABLE_VENUES;
      return _react2.default.createElement(
        'div',
        { className: 'vertical-venue-list' },
        (elements || []).slice(0, numItems).map(function (element) {
          return _this2.renderVenueItem(element);
        }),
        canShowLoadMore && _react2.default.createElement(
          'div',
          { className: 'vertical-venue-list__load-more', onClick: this.handleLoadMore },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vertical-venue-list.load.more',
            defaultMessage: 'Load more'
          })
        )
      );
    }
  }]);
  return VerticalVenueList;
}(_react.Component);

VerticalVenueList.propTypes = {
  elements: _propTypes2.default.array,
  showCount: _propTypes2.default.bool
};